import MFA from './MfaPage.vue'

export default MFA
